import { createAction, props } from '@ngrx/store';

import { User } from '../../models/user';

export const storeUser = createAction(
  '[User API] Store',
  props<{ payload: User }>()
);
